/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI Sales
 * Это Sales api сервер, для запросов от Frontend.  Для запросов требуется указать header с Authorization и типом Bearer.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { ItemAttributeValue } from './ItemAttributeValue'
import {
  ItemAttributeValueFromJSON,
  ItemAttributeValueFromJSONTyped,
  ItemAttributeValueToJSON,
  ItemAttributeValueToJSONTyped,
} from './ItemAttributeValue'

/**
 *
 * @export
 * @interface ItemAttribute
 */
export interface ItemAttribute {
  /**
   *
   * @type {string}
   * @memberof ItemAttribute
   */
  id: string
  /**
   *
   * @type {string}
   * @memberof ItemAttribute
   */
  name: string
  /**
   *
   * @type {string}
   * @memberof ItemAttribute
   */
  categoryId: string
  /**
   *
   * @type {string}
   * @memberof ItemAttribute
   */
  valueType: ItemAttributeValueTypeEnum
  /**
   *
   * @type {boolean}
   * @memberof ItemAttribute
   */
  isRequired: boolean
  /**
   *
   * @type {number}
   * @memberof ItemAttribute
   */
  createdAt: number
  /**
   *
   * @type {number}
   * @memberof ItemAttribute
   */
  updatedAt: number
  /**
   *
   * @type {ItemAttributeValue}
   * @memberof ItemAttribute
   */
  value?: ItemAttributeValue
}

/**
 * @export
 */
export const ItemAttributeValueTypeEnum = {
  String: 'STRING',
  Number: 'NUMBER',
  Boolean: 'BOOLEAN',
  Date: 'DATE',
  Time: 'TIME',
  Datetime: 'DATETIME',
  List: 'LIST',
  Object: 'OBJECT',
  None: 'NONE',
} as const
export type ItemAttributeValueTypeEnum =
  (typeof ItemAttributeValueTypeEnum)[keyof typeof ItemAttributeValueTypeEnum]

/**
 * Check if a given object implements the ItemAttribute interface.
 */
export function instanceOfItemAttribute(value: object): value is ItemAttribute {
  if (!('id' in value) || value['id'] === undefined) return false
  if (!('name' in value) || value['name'] === undefined) return false
  if (!('categoryId' in value) || value['categoryId'] === undefined)
    return false
  if (!('valueType' in value) || value['valueType'] === undefined) return false
  if (!('isRequired' in value) || value['isRequired'] === undefined)
    return false
  if (!('createdAt' in value) || value['createdAt'] === undefined) return false
  if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false
  return true
}

export function ItemAttributeFromJSON(json: any): ItemAttribute {
  return ItemAttributeFromJSONTyped(json, false)
}

export function ItemAttributeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ItemAttribute {
  if (json == null) {
    return json
  }
  return {
    id: json['id'],
    name: json['name'],
    categoryId: json['categoryId'],
    valueType: json['valueType'],
    isRequired: json['isRequired'],
    createdAt: json['createdAt'],
    updatedAt: json['updatedAt'],
    value:
      json['value'] == null
        ? undefined
        : ItemAttributeValueFromJSON(json['value']),
  }
}

export function ItemAttributeToJSON(json: any): ItemAttribute {
  return ItemAttributeToJSONTyped(json, false)
}

export function ItemAttributeToJSONTyped(
  value?: ItemAttribute | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value
  }

  return {
    id: value['id'],
    name: value['name'],
    categoryId: value['categoryId'],
    valueType: value['valueType'],
    isRequired: value['isRequired'],
    createdAt: value['createdAt'],
    updatedAt: value['updatedAt'],
    value: ItemAttributeValueToJSON(value['value']),
  }
}
